// extracted by mini-css-extract-plugin
module.exports = {"StartContainer":"style_StartContainer__e9GB9"};